import axios from '@/utils/request.js'

export const getSaleEmpData = (params) => { // 获取部门员工列表
  return axios.post('/goods/gas/company/getDepartOrgAndEmp', params)
}
